export default __webpack_public_path__ + "static/media/6.e25e2d35.jpg";